import React from "react";
import SignUpFormComponent from "./components/SignUpFormComponent";

export default function SignUpForm () {
    return (
        <SignUpFormComponent />
    )
}